<template>
  <div class="align-center d-flex flex-row">
      <header-logo :fields="item.fields" v-for="item in fields.items" :key="item.name"></header-logo>
  </div>
</template>

<script>
import HeaderLogo from './sub-components/HeaderLogo.vue';

export default {
  name: 'HeaderLogos',
  data() {
    return {};
  },
  props: {
    rendering: {
      type: Object,
      default: () => ({})
    },
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    HeaderLogo: HeaderLogo,
  },
};
</script>
<style lang="scss" scoped>
</style>
